import { RTE_TOKEN_ATTR } from '../constants';

/** *********************************************
 * Public Interface
 */

export const getTokenHtml = props => createFullToken(props);

export function mouseDownHandler($event) {
  const el = $event.target;
  if (el.getAttribute(RTE_TOKEN_ATTR)) {
    el.style.display = 'inline';
  }
}

export function mouseUpHandler($event) {
  const el = $event.target;
  if (el.getAttribute(RTE_TOKEN_ATTR)) {
    el.style.display = 'inline-block';
  }
}

export function clickHandler($event) {
  const isToken = $event.target.getAttribute(RTE_TOKEN_ATTR) !== null;
  if (isToken) {
    $event.stopPropagation();
    $event.preventDefault();
    return false;
  }
  return true;
}

/**
 * Provided string must be in the format "type|tag|displayName".
 * @param {string} data - Pipe delineated string with 'type', 'tag', and 'displayName' values
 * @return {{ type, tag, displayName }|null}
 */
export function parsePropsFromTokenData(data) {
  const vals = data.split('|');
  if (vals.length !== 3) {
    return null;
  }
  return {
    displayName: vals[2],
    tag: vals[1],
    type: vals[0],
  };
}

/**
 *
 * @param {string} html
 * @return {string}
 */
export function compress(html) {
  const tokenPattern = /<a\b[^>]*rte-token="(.*?)\|(.*?)\|(.*?)"[^>]*>(.*?)<\/a>/gm;
  const replacement = (fullMatch, type, tag) => createCompressedToken({ type, tag });
  return html.replace(tokenPattern, replacement);
}

/**
 *
 * @param {string} html
 * @param {Object} tokens
 * @return {*}
 */
export function decompress(html, tokens) {
  const tokenPattern = /\$\[(.*?)\|(.*?)]\$/gm;
  const replacement = (fullMatch, type, tag) => {
    const token = tokens.getToken(type, tag);
    const displayName = (token && token.displayName) || '?';
    return createFullToken({ type, tag, displayName });
  };
  return html.replace(tokenPattern, replacement);
}

/** *********************************************
 * Private Functions
 */

/**
 * compressedToken is in the format $[type|tag]$
 * @param {string} type
 * @param {string} tag
 * @return {string} compressedToken
 */
function createCompressedToken({ type, tag }) {
  return `$[${type}|${tag}]$`;
}

function createFullToken({ displayName, tag, type }) {
  return `<a 
    ${RTE_TOKEN_ATTR}="${type}|${tag}|${displayName}" 
    alt="Drag and drop to position in the text editor"
    class="${RTE_TOKEN_ATTR} ${type} fr-fic fr-dii fr-draggable"
    contenteditable="false"
    draggable="true"
    href="#"
    style="display: inline-block"
  >${displayName}</a>`;
}
